export const UNSUBSCRIBE_EMAIL_OPTIONS: Array<{
  heading: string;
  description: string;
  proFeature: boolean;
  key: string;
}> = [
  {
    heading: 'Recommended jobs',
    description: 'Get daily personalized job listings specially for you.',
    proFeature: false,
    key: 'recommendedjobs',
  },
  {
    heading: 'Job status',
    description: 'Receives status mails on  applied jobs',
    proFeature: false,
    key: 'jobStatus',
  },
  {
    heading: 'Newsletter',
    description:
      'Get relevant  courses and articles to help you land a job faster',
    proFeature: false,
    key: 'newsletter',
  },
];

export const UNSUBSCRIBE_COLLECTION_INFO = [
  {
    title: 'I am not looking for a job',
    key: 'notLooking',
    type: 1,
  },
  {
    title: 'The emails are not relevant to me',
    key: 'irrelaventEmails',
    type: 2,
  },
  {
    title: 'The emails are too frequent',
    key: 'frqEmails',
    type: 3,
  },
  {
    title: `I don't remember signing up for this`,
    key: 'dontKnow',
    type: 4,
  },
  {
    title: 'I find the emails inappropriate or spam',
    key: 'emailSpam',
    type: 5,
  },
  {
    title: 'Other (fill in the reason below)',
    key: 'other',
    type: 6,
  },
];
